import React from "react";
//#region  types
import { TranslationKeys } from "translations";
//#endregion
//#region  components
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import TodoCheck from "images/todo-check-green.png";
import cssExports from "theme/styles/main.module.scss";

const AllCompleteSimpleTodoCard: React.FC = () => {
  return (
    <Grid container direction="column" alignItems="center" className={cssExports.allCompleteSimpleTodoCard}>
      <Grid item className={cssExports.imageContainer}>
        <img src={TodoCheck} />
      </Grid>
      <Grid item className={cssExports.title}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.AllCompleteTitle)}
      </Grid>
      <Grid item className={cssExports.subTitle}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.AllCompleteMessage)}
      </Grid>
    </Grid>
  );
};

export default AllCompleteSimpleTodoCard;
